import { getBaseURL } from '@/environments'
const baseURL = getBaseURL()
const banner = baseURL + '/newadmin/public/api/banners/get/'
const sponsor = baseURL + '/newadmin/public/api/sponsor'
// const config = '/temporary_config.json'
const config = baseURL + '/newadmin/public/api/s/configs'
const about = {
  committeeCategory: baseURL + '/newadmin/public/api/about/committee',
  committee: baseURL + '/newadmin/public/api/about/committee/',
  chairmanBiography: baseURL + '/newadmin/public/api/about/chairman',
  workingcommittee: baseURL + '/newadmin/public/api/about/workingcommittee',
  workingcommitteeCategory: baseURL + '/newadmin/public/api/about/category/workingcommittee',
  workingcommitteeDuration: baseURL + '/newadmin/public/api/about/workingcommittee/duration'
}
const creativity = {
  program: baseURL + '/newadmin/public/api/creativeday/program',
  talkSymposium: baseURL + '/newadmin/public/api/creativeday/time/1',
  talkSymposiumDetail: baseURL + '/newadmin/public/api/creativeday/detail/',
  schoolCreativity: baseURL + '/newadmin/public/api/creativeday/room/2',
  schoolCreativityTime: baseURL + '/newadmin/public/api/creativeday/time/',
  schoolCreativityDetail: baseURL + '/newadmin/public/api/creativeday/detail/'
}

const news = {
  list: baseURL + '/newadmin/public/api/activity/list',
  detail: baseURL + '/newadmin/public/api/activity/'
}

const winners = baseURL + '/newadmin/public/api/winner'

const program = {
  category: baseURL + '/newadmin/public/api/archivevideocat',
  archive: baseURL + '/newadmin/public/api/archivevideo'
}

const gallery = {
  list: baseURL + '/newadmin/public/api/gallerycategory',
  year: baseURL + '/newadmin/public/api/galleryyear/',
  detail: baseURL + '/newadmin/public/api/gallery/'
}

const awards = {
  rules: baseURL + '/newadmin/public/api/awardrules',
  judge: {
    category: baseURL + '/newadmin/public/api/judgecategory',
    list: baseURL + '/newadmin/public/api/judge/'
  },
  categories: {
    link: baseURL + '/newadmin/public/api/award_link',
    list: baseURL + '/newadmin/public/api/award_category',
    detail: baseURL + '/newadmin/public/api/award/'
  }
}

const archive = {
  category: baseURL + '/newadmin/public/api/archive_category',
  subCategory: baseURL + '/newadmin/public/api/archive_subcategory/',
  content: baseURL + '/newadmin/public/api/archive/'
}

const symposium = {
  verifyAuth: baseURL + '/newadmin/public/api/auth/verify',
  signInWithCode: baseURL + '/newadmin/public/api/auth/signin-with-code',
  videoList: baseURL + '/newadmin/public/api/symposium',
  videoDetailById: baseURL + '/newadmin/public/api/symposium/detail/',
  roomList: baseURL + '/newadmin/public/api/symposium/rooms',
  dateAvailable: baseURL + '/newadmin/public/api/symposium/date-available'
}

export default {
  banner,
  sponsor,
  about,
  creativity,
  news,
  winners,
  program,
  gallery,
  awards,
  archive,
  symposium,
  config
}
